function AnalysisEnrolleesSpatialMatchesCardView() {
    "use strict";
    this.Id = -1;
    this.FullName = '';
    this.PrimaryId = '';
    this.TrackingDeviceSerialNumber = '';
    this.StartDetail = '';
    this.EndDetail = '';
    this.SpatialTrackStartDate = '';
    this.SpatialTrackEndDate = '';
    this.EnrolleeSpatialView = 'block';
    this.TrackSpatialView = 'none';
    this.EnrolleeSpatialPointCount = 0;
    this.Latitude = 0;
    this.Longitude = 0;
    this.IsExpanded = true;
    this.Type = 2;
}
if (typeof exports !== 'undefined') {
    module.exports = AnalysisEnrolleesSpatialMatchesCardView;
}